var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Moment from "moment";
import AcademicCalendarService from "./AcademicCalendar.service";
import PersonApplicationService from "./PersonApplication.service";
import CourseService from "./Course.service";
import DegreeService from "./Degree.service";
import LocationService from "./Location.service";
import ProgramService from "./Program.service";
import TagService from "./Tag.service";
import HoldService from "./Hold.service";
import PersonService from "./Person.service";
import SuccessScoreService from "./SuccessScore.service";
import RaceService from "./Race.service";
import HighSchoolService from "./HighSchool.service";
import StudentTypeService from "./StudentType.service";
import StudentStatusService from "./StudentStatus.service";
import EthnicityService from "./Ethnicity.service";
import ApplicationTypeService from "./ApplicationType.service";
import CourseSectionService from "./CourseSection.service";
import NumberService from "./Shared/Number.service";
import StateService from "./State.service";
import VeteranTypeService from "./VeteranType.service";
import ImportProcessService from "./ImportProcess.service";
import AdmitStatusService from "./AdmitStatus.service";
import StudentLoadIntentService from "./StudentLoadIntent.service";
import ResidencyStatusService from "./ResidencyStatus.service";
import HighSchoolGraduationTypeService from "./HighSchoolGraduationType.service";
import HighSchoolTranscriptStatusService from "./HighSchoolTranscriptStatus.service";
import HighSchoolTranscriptTypeService from "./HighSchoolTranscriptType.service";
import AreaOfStudyService from "./AreaOfStudy.service";
import PipelineService from "./Pipeline.service";
import StageService from "./Stage.service";
import DepartmentService from "./Department.service";
import FormService from "./Form.service";
import ProspectSourceService from "./ProspectSource.service";
const makeSimpleLoader = (serviceCall, keyOfId) => (ids) => serviceCall(ids).then((items) => items.reduce((sum, next) => {
    if (next[keyOfId] == null) {
        if (console.error) {
            console.error(`Could not find property ${keyOfId.toString()} in`, next);
        }
        return sum;
    }
    return Object.assign(Object.assign({}, sum), { 
        // @ts-expect-error - TS2464 - A computed property name must be of type 'string', 'number', 'symbol', or 'any'.
        [next[keyOfId]]: next });
}, {}));
const _applicationStatuses = makeSimpleLoader(PersonApplicationService.getApplicationStatusesById, "id");
const _state = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return StateService.findByIds(numIds);
}, "id");
const _applicationTypes = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return ApplicationTypeService.findAllByIds(numIds);
}, "id");
const _veteranTypes = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return VeteranTypeService.getVeteranTypes({ ids: numIds }).then(({ data }) => data);
}, "id");
const _courses = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return CourseService.search({ ids: numIds }).then(({ data }) => data);
}, "id");
const _degrees = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids;
    }
    else {
        numIds = [ids];
    }
    return DegreeService.findByIds(numIds);
}, "id");
const _majors = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids;
    }
    else {
        numIds = [ids];
    }
    // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
    return AreaOfStudyService.search({ ids: numIds }).then((result) => {
        return result.data;
    });
}, "id");
const _minors = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids;
    }
    else {
        numIds = [ids];
    }
    // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
    return AreaOfStudyService.search({ ids: numIds }).then((result) => {
        return result.data;
    });
}, "id");
const _concentrations = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids;
    }
    else {
        numIds = [ids];
    }
    // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
    return AreaOfStudyService.search({ ids: numIds }).then((result) => {
        return result.data;
    });
}, "id");
const _specializations = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids;
    }
    else {
        numIds = [ids];
    }
    // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
    return AreaOfStudyService.search({ ids: numIds }).then((result) => {
        return result.data;
    });
}, "id");
const _locations = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return LocationService.findLocationsById(numIds);
}, "id");
const _programs = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return ProgramService.findAllById(numIds);
}, "id");
const _departments = makeSimpleLoader((ids) => 
// @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
DepartmentService.search({ ids: Array.isArray(ids) ? ids : [ids] }).then(({ data }) => data), "id");
const _prospectSources = makeSimpleLoader((ids) => {
    const numIds = Array.isArray(ids) ? ids : [ids];
    return ProspectSourceService.search({ ids: numIds }).then(({ data }) => data);
}, "id");
const _forms = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids;
    }
    else {
        numIds = [ids];
    }
    return FormService.search({ ids: numIds }).then(({ data }) => data);
}, "id");
const _tags = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return TagService.findByIds(numIds);
}, "id");
const _holds = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return HoldService.findAllById(numIds);
}, "id");
const _races = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return RaceService.findByIds(numIds);
}, "id");
const _highSchools = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return HighSchoolService.search({ ids: numIds }).then(({ data }) => data);
}, "id");
const _studentTypes = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return StudentTypeService.findAllById(numIds);
}, "id");
const _studentStatuses = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return StudentStatusService.findAllById(numIds);
}, "id");
const _ethnicities = makeSimpleLoader((ids) => {
    let numIds;
    if (Array.isArray(ids)) {
        numIds = ids.map((id) => parseInt(id, 10));
    }
    else {
        numIds = [parseInt(ids, 10)];
    }
    return EthnicityService.findByIds(numIds);
}, "id");
const _terms = makeSimpleLoader(AcademicCalendarService.getTermsByIdIncludeCurrent, "id");
const _successScoringGroup = makeSimpleLoader((groupIds) => SuccessScoreService.getSuccessScoringGroupsById(Array.isArray(groupIds) ? groupIds : [groupIds]), "id");
const _person = makeSimpleLoader(PersonService.getPeopleByPersonId, "personId");
const _courseSection = makeSimpleLoader((ids) => CourseSectionService.search({ ids: Array.isArray(ids) ? ids : [ids] }).then(({ data }) => data), "id");
const _importProcess = makeSimpleLoader((ids) => {
    const parsedIds = Array.isArray(ids) ? ids.map(Number) : [Number(ids)];
    console.log(ids, parsedIds);
    return ImportProcessService.search({ ids: parsedIds })
        .then(({ data }) => data)
        .then((data) => {
        console.log("data", data);
        return data;
    });
}, "id");
const _admitStatus = makeSimpleLoader((ids) => 
// @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
AdmitStatusService.search({ ids: Array.isArray(ids) ? ids : [ids] }).then(({ data }) => data), "id");
const _studentLoadIntent = makeSimpleLoader((ids) => StudentLoadIntentService.search({
    // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
    ids: Array.isArray(ids) ? ids : [ids],
}).then(({ data }) => data), "id");
const _residencyStatus = makeSimpleLoader((ids) => ResidencyStatusService.search({
    // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
    ids: Array.isArray(ids) ? ids : [ids],
}).then(({ data }) => data), "id");
const _highSchoolGraduationType = makeSimpleLoader((ids) => HighSchoolGraduationTypeService.search({
    // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
    ids: Array.isArray(ids) ? ids : [ids],
}).then(({ data }) => data), "id");
const _highSchoolTranscriptStatus = makeSimpleLoader((ids) => HighSchoolTranscriptStatusService.search({
    // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
    ids: Array.isArray(ids) ? ids : [ids],
}).then(({ data }) => data), "id");
const _highSchoolTranscriptType = makeSimpleLoader((ids) => HighSchoolTranscriptTypeService.search({
    // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
    ids: Array.isArray(ids) ? ids : [ids],
}).then(({ data }) => data), "id");
const _pipelines = makeSimpleLoader((ids) => 
// @ts-expect-error - TS2322 - Type 'Promise<Pipeline[] | PipelineLite[]>' is not assignable to type 'Promise<Pipeline[]>'.
PipelineService.search({
    // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
    pipelineIds: Array.isArray(ids) ? ids : [ids],
}).then(({ data }) => data), "id");
const _stages = makeSimpleLoader((ids) => StageService.search({
    // @ts-expect-error - TS2322 - Type 'string[]' is not assignable to type 'number[]'.
    stageIds: Array.isArray(ids) ? ids : [ids],
}).then(({ data }) => data), "id");
const _number = (numbers) => __awaiter(void 0, void 0, void 0, function* () {
    return (Array.isArray(numbers) ? numbers : [numbers]).reduce((sum, number) => {
        if (!NumberService.isValid(number)) {
            throw new Error(`Could not parse ${number} into number`);
        }
        const result = parseFloat(number);
        return Object.assign(Object.assign({}, sum), { [number]: result });
    }, {});
});
const _boolean = (booleans) => __awaiter(void 0, void 0, void 0, function* () {
    return (Array.isArray(booleans) ? booleans : [booleans]).reduce((sum, boolean) => (Object.assign(Object.assign({}, sum), { [boolean.toString()]: boolean === "true" })), {});
});
const _string = (strings) => __awaiter(void 0, void 0, void 0, function* () {
    return (Array.isArray(strings) ? strings : [strings]).reduce((sum, string) => (Object.assign(Object.assign({}, sum), { [string]: string })), {});
});
// @ts-expect-error - TS2709 - Cannot use namespace 'Moment' as a type.
const _moment = (moments) => __awaiter(void 0, void 0, void 0, function* () {
    return (Array.isArray(moments) ? moments : [moments]).reduce((sum, moment) => (Object.assign(Object.assign({}, sum), { [moment]: Moment(moment) })), {});
});
/**
 * The keys in this object are both the attribute name that we check on params to pass into the loader
 * and the key on the filterValue object that getValuesFromURL will resolve with.  The value is the loader
 * that is used to load that value.  This object is then merged into current filter to make an ad hoc filter.
 * In other words, this object defines keys to override on a filter and the method that should be used to
 * fetch the values for that override.  For example, if this object was {a: getA, b: getB}, and a filter was defined
 * as {b: 'b in filter', c: 'c in filter'} getValuesFromURL would return
 * {a: [valueReturnedFromGetA], b: [valueReturnedFromGetB], c: 'c in filter'}
 *
 * [FILTER_PARAM_NAME] should not be included in this object.
 *
 */
export const FilterValueStructure = {
    advisors: _person,
    coaches: _person,
    applicationAgeMoreThanDays: _number,
    applicationAgeLessThanDays: _number,
    applicationStatuses: _applicationStatuses,
    applicationTerms: _terms,
    courses: _courses,
    courseSuccessScoringGroups: _successScoringGroup,
    degrees: _degrees,
    noDegrees: _degrees,
    majors: _majors,
    noMajors: _majors,
    minors: _minors,
    noMinors: _minors,
    concentrations: _concentrations,
    noConcentrations: _concentrations,
    specializations: _specializations,
    noSpecializations: _specializations,
    lastKEAgeMoreThanDays: _number,
    locations: _locations,
    programs: _programs,
    noPrograms: _programs,
    registrationTerms: _terms,
    noRegistrationTerms: _terms,
    inPersonsCaseload: _person,
    searchFollowersOnly: _boolean,
    includeAnyTags: _boolean,
    excludeAnyTags: _boolean,
    tags: _tags,
    noTags: _tags,
    termSuccessScoringGroups: _successScoringGroup,
    holds: _holds,
    noHolds: _holds,
    maxMajorGpa: _number,
    minMajorGpa: _number,
    maxCumulativeGpa: _number,
    minCumulativeGpa: _number,
    minCumulativeCreditHours: _number,
    maxCumulativeCreditHours: _number,
    anticipatedGraduationDateFrom: _moment,
    anticipatedGraduationDateTo: _moment,
    lastAssignmentSubmittedMoreThanDays: _number,
    lastAssignmentSubmittedLessThanDays: _number,
    hasOpenAlerts: _boolean,
    races: _races,
    noRaces: _races,
    city: _string,
    state: _state,
    zipCode: _number,
    personId: _string,
    gender: _string,
    highSchools: _highSchools,
    noHighSchools: _highSchools,
    studentTypes: _studentTypes,
    noStudentTypes: _studentTypes,
    studentStatuses: _studentStatuses,
    noStudentStatuses: _studentStatuses,
    minAge: _number,
    maxAge: _number,
    maxHighSchoolStartDate: _moment,
    minHighSchoolStartDate: _moment,
    minHighSchoolGPA: _number,
    maxHighSchoolGPA: _number,
    maxHighSchoolEndDate: _moment,
    minHighSchoolEndDate: _moment,
    isMinority: _boolean,
    ethnicities: _ethnicities,
    noEthnicities: _ethnicities,
    applicationTypes: _applicationTypes,
    noApplicationTypes: _applicationTypes,
    veteranTypes: _veteranTypes,
    noVeteranTypes: _veteranTypes,
    isVeteran: _boolean,
    isFirstGeneration: _boolean,
    courseSections: _courseSection,
    terms: _terms,
    includesCurrentTermsForCourses: _boolean,
    importProcesses: _importProcess,
    highSchoolTranscriptDateFrom: _moment,
    highSchoolTranscriptDateTo: _moment,
    highSchoolTranscriptStatus: _highSchoolTranscriptStatus,
    noHighSchoolTranscriptStatus: _highSchoolTranscriptStatus,
    highSchoolTranscriptType: _highSchoolTranscriptType,
    noHighSchoolTranscriptType: _highSchoolTranscriptType,
    highSchoolYearAttendedStartFrom: _number,
    highSchoolYearAttendedStartTo: _number,
    highSchoolYearAttendedEndFrom: _number,
    highSchoolYearAttendedEndTo: _number,
    highSchoolGraduationType: _highSchoolGraduationType,
    noHighSchoolGraduationType: _highSchoolGraduationType,
    applicationStudentLoadIntent: _studentLoadIntent,
    noApplicationStudentLoadIntent: _studentLoadIntent,
    applicationResidencyStatus: _residencyStatus,
    noApplicationResidencyStatus: _residencyStatus,
    applicationAdmitStatus: _admitStatus,
    noApplicationAdmitStatus: _admitStatus,
    applicationStudentType: _studentTypes,
    noApplicationStudentType: _studentTypes,
    applicationLocations: _locations,
    noApplicationLocations: _locations,
    pipelines: _pipelines,
    stages: _stages,
    pipelineStaff: _person,
    intendedStartTerms: _terms,
    noIntendedStartTerms: _terms,
    interestedPrograms: _programs,
    noInterestedPrograms: _programs,
    interestedDepartments: _departments,
    noInterestedDepartments: _departments,
    daysSinceSubmittedFormMin: _number,
    daysSinceSubmittedFormMax: _number,
    searchFilterSubmittedForms: _forms,
    noSearchFilterSubmittedForms: _forms,
    submittedFormsAnswerInterestedPrograms: _programs,
    noSubmittedFormsAnswerInterestedPrograms: _programs,
    submittedFormsAnswerIntendedStartTerms: _terms,
    noSubmittedFormsAnswerIntendedStartTerms: _terms,
    submittedFormsAnswerDepartmentInterests: _departments,
    noSubmittedFormsAnswerDepartmentInterests: _departments,
    prospectSources: _prospectSources,
    noProspectSources: _prospectSources,
};
/**
 * Loads fields defined in the url for student search.
 */
export default class StudentSearchParamsService {
    constructor() {
        this._cache = {};
        /**
         * Gets filter values from the url, given that the url parameters are stored in params.
         * This will fetch all the necessary values in parallel and then join them together.
         * Returns the values and whether this filter is ad hoc.
         *
         * @param {object} params - object of either strings or array of strings
         * @returns {Promise<{}>} the filter values
         */
        this.getValuesFromURL = (params) => {
            // If it isn't ad hoc, there are not ad hoc params.  Don't do any additional work.
            if (!StudentSearchParamsService.isAdhoc(params)) {
                return Promise.resolve({});
            }
            // Return a promise of the filter values
            return Promise.all(
            // Make an array of promises which fetch the necessary values in parallel.
            Object.keys(FilterValueStructure).map((key) => {
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly advisors: Loader<PersonLite>; readonly coaches: Loader<PersonLite>; readonly applicationAgeMoreThanDays: Loader<number>; ... 101 more ...; readonly noAcademicInterests: Loader<...>; }'.
                return this._queryWrapper(key, params[key], FilterValueStructure[key]);
            })).then((queryValues) => 
            // Reduce all the slices into one object
            queryValues.reduce((accValues, curValue) => (Object.assign(Object.assign({}, accValues), curValue)), {}));
        };
        /**
         * Returns promise of {} if the paramName isn't defined on params.  If it is defined, calls the loader
         * with params[paramName] and returns promise of {paramName: that value}.
         *
         * @private
         */
        this._queryWrapper = (paramName, params, loader) => __awaiter(this, void 0, void 0, function* () {
            // Check if null or if empty array and (conveniently) if empty string
            if (params == null || !params.length) {
                return { [paramName]: [] };
            }
            const paramsArray = Array.isArray(params) ? params : [params];
            try {
                // Find what's not in the cache.
                const newParams = paramsArray.filter((param) => !Object.keys(this._cache[paramName] || {}).includes(param));
                if (newParams.length) {
                    // add results to the cache.
                    const result = yield loader(newParams);
                    this._cache[paramName] = Object.assign(Object.assign({}, this._cache[paramName]), result);
                }
                return {
                    [paramName]: paramsArray.map((param) => this._cache[paramName][param]),
                };
            }
            catch (error) {
                if (console.error) {
                    console.error(`Error fetching ${paramName} with ids ${Array.isArray(params) ? params.join(", ") : params}`, error);
                }
                return {};
            }
        });
    }
    /**
     * Returns whether or not this filter is ad hoc.
     */
    static isAdhoc(params) {
        return Object.keys(FilterValueStructure).some((paramName) => params[paramName] !== undefined);
    }
}
